import script from "./slideProductOne.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductOne.vue?vue&type=script&setup=true&lang=js"

import "./slideProductOne.vue?vue&type=style&index=0&id=5e6dd033&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6dd033"]])

export default __exports__